document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM fully loaded and parsed");

  const tocList = document.getElementById('toc-list');
  console.log("TOC list element:", tocList);
  if (!tocList) {
    console.error("TOC list not found");
    return;
  }

  const articleContent = document.querySelector('.article-template__content');
  console.log("Article content element:", articleContent);

  if (!articleContent) {
    console.error("Article content not found");
    return;
  }

  const headings = articleContent.querySelectorAll('h1, h2, h3');
  console.log("Headings found:", headings.length);

  if (headings.length > 0) {
    headings.forEach((heading, index) => {
      const id = 'heading-' + index;
      heading.id = id;

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent;

      li.appendChild(a);
      tocList.appendChild(li);

      console.log("Added TOC entry for:", heading.textContent);
    });
  } else {
    console.log("No headings found to populate TOC");
    const tocContainer = document.querySelector('.toc-container');
    tocContainer.style.display = 'none';
  }
});